import systemAlert from "../utils/systemAlert"

export const testMsg = () => {
  setTimeout(() => {
    systemAlert('체험하기에서는 사용할 수 없는 기능입니다.')
  }, 100)
}